import React from "react"
import { useDropZonePaint } from "../lib/hooks/useDropZoneStyle"
import { ZoneEntity, ZoneType } from "../lib/types/zone"
import GeoJSONLayer from "../mapbox/GeoJSONLayer"

interface ZonesMapLayerProps {
  zone: ZoneEntity
  type: ZoneType
  isSelected: boolean
}

const _ZonesMapLayer: React.FC<ZonesMapLayerProps> = ({ zone, type, isSelected }) => {
  const { fillColor, fillOutlineColor, fillOpacity, lineColor } = useDropZonePaint({
    type,
    isSelected,
    isZoneMap: true,
  })

  const multiPolygonFeature = {
    type: "Feature",
    geometry: zone.polygon,
    properties: { ...zone },
  } as GeoJSON.Feature

  if (!isSelected) {
    // only fill
    return (
      <GeoJSONLayer
        id={zone.uuid}
        data={multiPolygonFeature}
        fillPaint={{
          fillColor,
          fillOpacity,
        }}
        linePaint={{
          lineColor: fillOutlineColor,
        }}
      />
    )
  }

  // fill and stroke
  return (
    <>
      {/* FILL */}
      <GeoJSONLayer
        id={zone.uuid}
        data={multiPolygonFeature}
        fillPaint={{
          fillColor,
          fillOpacity,
        }}
        linePaint={{
          lineColor,
          lineWidth: 2,
          lineDasharray: [2, 1],
        }}
      />
    </>
  )
}

const ZonesMapLayer = React.memo(_ZonesMapLayer)

export default ZonesMapLayer
